<template>
    <div>
        <form enctype="multipart/form-data" novalidate>
            <div
                    class="az-drop-file"
                    :style="{ height: height }"
                    @drop.prevent="onDropFiles($event)"
                    @dragover.prevent=""
            >
                <input
                        ref="fileInput"
                        type="file"
                        :multiple="multiple"
                        class="input-file"
                        :name="uploadFieldName"
                        :accept="accept"
                        @change="onSelectFiles($event.target.files)"
                />
                <div class="center">
                    <slot></slot>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    name: 'CompraDiretaUploadArquivo',
    props: {
        accept: {
            type: String,
            default: '*'
        },
        thumbnail: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: '200px'
        },
        multiple: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            uploadFieldName: 'file',
            fileMaxSize: '16Mb'
        }
    },
    methods: {
        calcFileSize(bytes, unit) {
            const k = 1024
            return parseFloat((bytes / Math.pow(k, unit)).toFixed(2))
        },
        createFormData(file) {
            const formData = new FormData()
            formData.append(this.uploadFieldName, file)
            formData.append('thumbnail', this.thumbnail)
            return formData
        },
        createPayload(file) {
            return {
                formData: this.createFormData(file),
                filename: file.name
            }
        },
        getMaxSizeConfig() {
            const maxSize = this.fileMaxSize.replace(/([A-Za-z]+)/g, '')
            const unit = ['B', 'KB', 'MB', 'GB', 'TB'].indexOf(this.fileMaxSize.replace(/\d+/g, '').toUpperCase())
            return { maxSize, unit }
        },
        isFileBiggerThanExpected(file) {
            const { maxSize, unit } = this.getMaxSizeConfig()
            const fileSize = this.calcFileSize(file.size, unit)
            return fileSize > maxSize
        },
        onDropFiles(evt) {
            if (!evt || !evt.dataTransfer) {
                this.$emit('debug', { stage: 'drop:no-dataTransfer' })
                return
            }
            const items = evt.dataTransfer.items
            if (items && Object.keys(items).length) {
                const files = []
                Object.keys(items).forEach(key => {
                    const item = items[key]
                    if (item && item.kind === 'file' && typeof item.getAsFile === 'function') {
                        const f = item.getAsFile()
                        if (f) files.push(f)
                    }
                })
                this.$emit('debug', { stage: 'drop:items', count: files.length })
                if (files.length) {
                    this.uploadFiles(files)
                    return
                }
            }
            const dtFiles = evt.dataTransfer.files
            if (dtFiles && dtFiles.length) {
                this.$emit('debug', { stage: 'drop:files', count: dtFiles.length })
                this.uploadFiles(dtFiles)
            } else {
                this.$emit('debug', { stage: 'drop:empty' })
            }
        },
        onSelectFiles(fileList) {
            if (!fileList.length) {
                this.$emit('debug', { stage: 'select:empty' })
                return
            }
            this.$emit('debug', { stage: 'select', count: fileList.length })
            this.uploadFiles(fileList)
            this.resetSelectedFiles()
        },
        openFileSelector() {
            const input = this.$refs.fileInput
            if (input && typeof input.click === 'function') {
                input.click()
            }
        },
        uploadFiles(fileList) {
            Array.from(Array(fileList.length).keys()).map(x => {
                const file = fileList[x]
                if (this.isFileBiggerThanExpected(file)) {
                    this.throwFileExceedMaxLimitSizeEvent(file)
                } else {
                    const payload = this.createPayload(file)
                    this.$emit('uploadArquivo', payload)
                }
            })
        },
        resetSelectedFiles() {
            const input = this.$refs.fileInput
            if (input) input.value = ''
        },
        throwFileExceedMaxLimitSizeEvent(file) {
            this.$emit('error', {
                type: 'FILE_EXCEEDED_MAX_SIZE_LIMIT',
                filename: file.name
            })
        }
    }
}
</script>

<style scoped lang="stylus">
.az-drop-file
  border: 2px dashed #ccc
  margin: 10px 0
  padding: 30px 0 20px
  align-content: center
  align-items: center
  text-align: center
  background-color: #eeeeee
  color: #7b7b7b
  display: flex
  position: relative

  &:hover
    border-color: #939393

  .center
    margin: 0 auto
    padding: 0

  .input-file
    opacity: 0
    position: absolute
    left: 0
    top: 0
    width: 10px
    height: 10px
    z-index: 1

  &__big
    padding: 70px 0 60px !important

  p
    width: 100%
    color: #777
    font-size: 13px
    margin-bottom: 0
    margin-top: 15px

  a
    background-color: var(--v-primary-base) !important
    border: 1px solid var(--v-primary-base) !important
    color: white
    padding: 10px 15px 10px 10px
    border-radius: 3px
    font-size: 13px
    &:hover
      background-color: var(--v-primary-darken1) !important

    i
      color: white !important
      position: relative
      top: 2px
      font-size: 18px
      margin-right: 5px
</style>
